import { UserX } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Card } from '@/components/ui/card'

import { BackButton, PageHeader } from '@/components/atoms'

export const CustomerNotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="mx-auto w-full max-w-[1088px] pb-10">
      <PageHeader
        size="large"
        back={<BackButton onClick={() => navigate('/customers')} label="Back to customers" />}
        title="Customer"
      />
      <Card className="flex flex-col items-center justify-center px-4 py-14 text-center">
        <span className="mb-4 grid size-20 place-items-center rounded-full bg-subdued" aria-hidden="true">
          <UserX className="size-8 text-faint" />
        </span>
        <h2 className="text-heading-md text-ink">Customer not found</h2>
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">
          The customer you're looking for doesn't exist or was deleted.
        </p>
      </Card>
    </div>
  )
}
